export class PivotSave {
    formatName: string;
    reportType: string;
    reportTitle: string;
    showOptions: boolean;
    showFilter: boolean;
    showAdditionalFilter: boolean;
    showColumnFilter: boolean;
    showFormat: boolean;
    showSave: boolean;
    showExport: boolean;
    showPrint: boolean;
    lineChart: boolean;
    barChart: boolean;
    doughnutChart: boolean;
    radarChart: boolean;
    pieChart: boolean;
    polarAreaChart: boolean;
}

export class ToolbarConfig {
    constructor() {
        this.optionsConfig = new OptionConfig();
        this.filterConfig = new FilterConfig();
        this.formatConfig = new FormatConfig();
        this.pivotTypeConfig = new PivotTypeConfig();
        this.exportConfig = new ExportConfig();
        this.fullscreenConfig = new FullscreenConfig();
        this.saveConfig = new SaveConfig();
    }

    private _class: string = 'row no-margin';
    public get class() {
        return this._class;
    }
    public set class(value: string) {
        this._class = value;
    }
    optionsConfig: OptionConfig;
    filterConfig: FilterConfig;
    formatConfig: FormatConfig;
    pivotTypeConfig: PivotTypeConfig;
    exportConfig: ExportConfig;
    fullscreenConfig: FullscreenConfig;
    saveConfig: SaveConfig;
}

export class OptionConfig {
    private _class: string = 'col-md-2 col-sm-2 col-xs-6';
    public get class() {
        return this._class;
    }
    public set class(value: string) {
        this._class = value;
    }

    private _icon: string = 'fa fa-fw fa-table';
    public get icon() {
        return this._icon;
    }
    public set icon(value: string) {
        this._icon = value;
    }

    private _text: string = 'Options';
    public get text() {
        return this._text;
    }
    public set text(value: string) {
        this._text = value;
    }

    private _title: string = 'Configure Pivot report columns, rows, values and custom fields';
    public get title() {
        return this._title;
    }
    public set title(value: string) {
        this._title = value;
    }
}

export class FilterConfig {
    private _class: string = 'col-md-1 col-sm-1 col-xs-6';
    public get class() {
        return this._class;
    }
    public set class(value: string) {
        this._class = value;
    }

    private _icon: string = 'fa fa-fw fa-filter';
    public get icon() {
        return this._icon;
    }
    public set icon(value: string) {
        this._icon = value;
    }

    private _text: string = 'Filter';
    public get text() {
        return this._text;
    }
    public set text(value: string) {
        this._text = value;
    }

    private _title: string = 'Add extra filter to pivot report';
    public get title() {
        return this._title;
    }
    public set title(value: string) {
        this._title = value;
    }
}

export class FormatConfig {
    private _class: string = 'col-md-2 col-sm-2 col-xs-6';
    public get class() {
        return this._class;
    }
    public set class(value: string) {
        this._class = value;
    }

    private _icon: string = 'fa fa-fw fa-pencil-square-o';
    public get icon() {
        return this._icon;
    }
    public set icon(value: string) {
        this._icon = value;
    }

    private _text: string = 'Format';
    public get text() {
        return this._text;
    }
    public set text(value: string) {
        this._text = value;
    }

    private _title: string = 'Format the fields';
    public get title() {
        return this._title;
    }
    public set title(value: string) {
        this._title = value;
    }
}

export class PivotTypeConfig {
    private _class: string = 'col-md-2 col-sm-2 col-xs-6 text-lg-right text-md-right text-sm-right';
    public get class() {
        return this._class;
    }
    public set class(value: string) {
        this._class = value;
    }

    private _title: string = 'Change the Format of the pivot report.';
    public get title() {
        return this._title;
    }
    public set title(value: string) {
        this._title = value;
    }
}

export class ExportConfig {
    private _class: string = 'col-md-2 col-sm-2 col-xs-6 text-lg-right text-md-right text-sm-right';
    public get class() {
        return this._class;
    }
    public set class(value: string) {
        this._class = value;
    }

    private _icon: string = 'fa fa-fw fa-download';
    public get icon() {
        return this._icon;
    }
    public set icon(value: string) {
        this._icon = value;
    }

    private _text: string = 'Export';
    public get text() {
        return this._text;
    }
    public set text(value: string) {
        this._text = value;
    }

    private _title: string = 'Export report to excel,pdf or print the report';
    public get title() {
        return this._title;
    }
    public set title(value: string) {
        this._title = value;
    }
}

export class FullscreenConfig {
    private _class: string = 'col-md-2 col-sm-2 col-xs-6 text-lg-right text-md-right text-sm-right';
    public get class() {
        return this._class;
    }
    public set class(value: string) {
        this._class = value;
    }

    private _icon: string = 'fa fa-fw fa-arrows-alt';
    public get icon() {
        return this._icon;
    }
    public set icon(value: string) {
        this._icon = value;
    }

    private _closeIcon: string = 'fa fa-fw fa-times';
    public get closeIcon() {
        return this._closeIcon;
    }
    public set closeIcon(value: string) {
        this._closeIcon = value;
    }

    private _text: string = 'Fullscreen';
    public get text() {
        return this._text;
    }
    public set text(value: string) {
        this._text = value;
    }

    private _closeText: string = 'Close';
    public get closeText() {
        return this._closeText;
    }
    public set closeText(value: string) {
        this._closeText = value;
    }

    private _title: string = 'Show Fullscreen';
    public get title() {
        return this._title;
    }
    public set title(value: string) {
        this._title = value;
    }

    private _closeTitle: string = 'Close Fullscreen';
    public get closeTitle() {
        return this._closeTitle;
    }
    public set closeTitle(value: string) {
        this._closeTitle = value;
    }
}

export class SaveConfig {
    private _class: string = 'col-md-1 col-sm-1 col-xs-6';
    public get class() {
        return this._class;
    }
    public set class(value: string) {
        this._class = value;
    }

    private _icon: string = 'fa fa-fw fa-save';
    public get icon() {
        return this._icon;
    }
    public set icon(value: string) {
        this._icon = value;
    }

    private _text: string = 'Save';
    public get text() {
        return this._text;
    }
    public set text(value: string) {
        this._text = value;
    }

    private _title: string = 'Save';
    public get title() {
        return this._title;
    }
    public set title(value: string) {
        this._title = value;
    }
}

